import React from 'react';
import {Link} from 'gatsby'
import {StaticImage} from 'gatsby-plugin-image'
import styled from 'styled-components'
const leftArrow ='../assets/images/left-arrow.svg'
const rightArrow ='../assets/images/right-arrow.svg'
const FooterNav = styled.div`
    background: black;
    color: white;
    margin-top: 8.75rem;
    padding: 6rem 0;
     a {
        color: white;
        text-decoration: none;
    }
    .footer-nav-grid {
        display: flex;
        justify-content: space-between;
        span {
            display: block;
        }

    }
    .next-post {
        text-align: right;
    }
    .footer-nav-post-title {
        font-size: 3rem;
        font-family: "Ogg-Roman", serif;
        padding-bottom: 4rem;
        padding-top: 1rem;
    }
    @media all and (max-width: 767px) {
        .footer-nav-grid {
            display: block;
        }
        .next-post, .prev-post {
            text-align: center;
        }
        .next-post {
            margin-top: 2rem;
        }
         .footer-nav-post-title {
             font-size: 2rem;
         }
    }
`

const CaseStudyFooterNav = ({prevTitle, prevUrl, nextTitle, nextUrl}) => {
  return (
      <FooterNav>
          <div className="contain">
              <div className="footer-nav-grid" role="navigation" aria-label="Work Studies">
                  <div className="prev-post">
                      {(prevTitle && (prevTitle !== 'Animo'))&&  
                        <Link to={prevUrl} rel="prev">        
                        <span>Previous Project</span>
                        <span className="footer-nav-post-title">
                            {prevTitle}
                        </span> 
                        <StaticImage quality={100} src={leftArrow} alt="left arrow" />
                        </Link> 
                      }                  
                  </div>
                    <div className="next-post">
                        {(nextTitle && (nextTitle !== 'Animo')) &&
                            <Link to={nextUrl} rel="next">        
                            <span>Next Project</span>
                            <span className="footer-nav-post-title">
                                {nextTitle}
                            </span> 
                            <StaticImage quality={100} src={rightArrow} alt="right arrow" />
                            </Link>   
                        }
                  </div>
              </div>
          </div>
      </FooterNav>
  )
};

export default CaseStudyFooterNav;
